import React from 'react';
import {
    getFirstWeekDay,
    getLastWeekDay,
    formatWithDayOrder,
    getCurrentFormattedDate,
} from '../../../../Utils/timeConvertorHelper';
import { SpaceBetweenRow, Row, OuterMargin } from '../../../Layouts';
import { Text, TruncatedText } from '../../../UI/Text';
import CalendarToggler from '../../../Components/CalendarToggler';
import { DateRow, WeekChallengeButton, WeekChallengeContainer } from './style';
import { AddButton } from '../../Members/style';
import { timeFormats } from '../../../../Constants/timeFormats';

export const Header = ({
    weekSelected,
    toggleNextWeek,
    togglePreviousWeek,
    toggleToday,
    onToggleModal,
    onToggleClassModal,
    weekChallenge,
}) => (
    <OuterMargin bottom={'28px'}>
        <SpaceBetweenRow>
            <Row>
                <DateRow>
                    <Text weight={'bold'} fontSize={22}>
                        {formatWithDayOrder(getFirstWeekDay(weekSelected))}
                    </Text>
                    <Text weight={'bold'} fontSize={22}>
                        &nbsp; - &nbsp;
                    </Text>
                    <Text weight={'bold'} fontSize={22}>
                        {formatWithDayOrder(getLastWeekDay(weekSelected))}
                    </Text>
                    <Text weight={100} marginLeft={'10px'} fontSize={22}>
                        {getCurrentFormattedDate(timeFormats.YEAR)}
                    </Text>
                </DateRow>

                <OuterMargin left={'10px'}>
                    <CalendarToggler
                        onToggleBack={togglePreviousWeek}
                        onToggleForward={toggleNextWeek}
                        onToggleNow={toggleToday}
                    />
                </OuterMargin>

                <OuterMargin left={'10px'}>
                    {Object.keys(weekChallenge).length === 0 ? (
                        <WeekChallengeButton onClick={() => onToggleModal(1)}>
                            <Text weight={100} fontSize={12} opacity={0.75}>
                                Add challenge of the week
                            </Text>
                        </WeekChallengeButton>
                    ) : (
                        <WeekChallengeContainer>
                            <Text opacity={0.75} fontSize={10}>
                                🏆 Challenge of the week:
                            </Text>
                            <TruncatedText fontSize={12}>
                                {weekChallenge.workout ? weekChallenge.workout.title : ''}
                            </TruncatedText>
                        </WeekChallengeContainer>
                    )}
                </OuterMargin>
            </Row>

            <AddButton onClick={onToggleClassModal}>Add</AddButton>
        </SpaceBetweenRow>
    </OuterMargin>
);



// WEBPACK FOOTER //
// ./src/UI/Containers/GymAdminPanel/Calendar/Header.js